import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
const cn = {
  // 登录页
  login: {
    title: '用户登录',
    username: '用户名',
    password: '密码',
    verify_code: '验证码',
    btn: '登录',

    header_title: '什么是海外推广营销资源',
    header_content: '截至目前，公司旗下产品已覆盖超过150个国家和地区、75个语种，在40多个国家和地区位居应用商店总榜前列，通过产品帮您连接国际用户，精准推送您的广告信息,满足您的海外推广需求',
    header_desc: '资讯海外推广',

    item1_title: '海量用户',
    item1_content: '全球覆盖超过，150个国家和地区<br />登顶40多个国家应用商店',
    item2_title: '原生沉浸',
    item2_content: '优质内容，原生传播，<br />无缝融入常规内容推荐流',
    item3_title: '效果可视',
    item3_content: '多维数据实时展示，<br />您的营销好帮手',
    item4_title: '流量优质',
    item4_content: '基于抖音平台，优质用户流量，<br />再升级人群画像定向',
    
    username_verify: '用户名不能为空',
    password_verify: '密码不能为空',
    code_verify: '验证码有误',
    code_null: '验证码不能为空'
  },

  // 公共部分
  common: {
    website: 'TikTok广告管理',
    nav1: '首页',
    nav2: '推广',
    nav2_1: '广告计划',
    nav2_2: '广告组',
    nav2_3: '广告',
    nav3: '报表',
    nav4: '账单',
    nav5: '账户中心',
    user_center: '个人中心',
    exit_system: '退出系统',
    empty_text: '暂无数据',
    layer_btn_cancel: '取消',
    layer_btn_sure: '确定'
  },

  // 首页
  index: {
    title: '数据趋势',
    select_font: '全部',
    btn_1: '消费（元）',
    btn_2: '展现（次）',
    btn_3: '点击（次）',
    hello: '您好',
    pass: '审核通过',
    balance: '推广余额',
    good: '合规信用值',
    product_title1: '信息流推广',
    product_title1_1: '日总预算(元)',
    product_btn1: '进入',
    product_title2: 'Thdudbui推广',
    product_content2: 'Thdudbui推广通过精准识别用户搜索需求和意图，触发行业定制化的搜索特型结果。',
    product_btn2: '不可申请',
    product_title3: '知识营销',
    product_content3: '知识营销通过解答网民问题直达相关需求，深度影响消费决策，在长期内形成品牌与内容营销的协同效应 。',

    layer_title: '修改账户预算',
    layer_form_title1: '预算方式',
    layer_form_btn1: '不限预算',
    layer_form_btn2: '指定预算',
    layer_form_title2: '指定预算',
    layer_form_desc2: '预算设置0元即暂停',
    budget_title: '不限定预算',
  },

  // 报表
  report: {
    title: '效果数据',
    condition1: '时间',
    condition2: '广告计划',
    condition3: '广告组',
    condition4: '广告',
    condition_label: '不限',
    options1: '点击数',
    options2: '展现数',
    options3: '消耗（元）',
    search_btn: '查询',
    item1: '曝光量（次）',
    item2: '点击量（次）',
    item3: '点击率',
    item4: '点击均价（元）',
    item5: '消耗金额（元）',
    td1: '时间',
    td2: '展现数',
    td3: '点击数',
    td4: '点击率',
    td5: '消耗(元)'
  },

  // 账单
  bill: {
    title: '账单',
    balance: '我的余额(元)',
    freeze_money: '冻结金额(元)',
    condition1: '日期',
    condition2: '类型',
    condition_label: '不限',
    search_btn: '查询',
    td1: '公司邮箱',
    td2: '公司名称',
    td3: '日期',
    td4: '类型',
    td5: '金额(元)',
    td6: '交易号',
    td7: '备注',
    type1: '账号充值',
    type2: '消耗',
  },

  // 账户中心
  user: {
    title: '账户中心',
    default_title1: '基础信息',
    line1: '代理商ID：',
    line2: '公司名称：',
    line3: '通讯地址：',
    line4: '网站链接：',
    line5: '产品名称：',
    line6: '联系人姓名：',
    line7: '联系人手机号：',
    line8: '营业执照号：',
    default_title2: '账户资质',
    label1: '营业执照',
    label2: 'ICP资质备案',
    td1: '营业执照统一社会信用代码',
    td2: '资质到期日期'
  },

  // 广告列表页
  adv: {
    plan_title: '广告系列',
    group_title: '广告组',
    adv_title: '广告',
    click: '点击数',
    read: '展现数',
    pay: '消耗（元）',
    condition: '所有时间',
    icon_type: '图表类型',
    add_title: '添加广告系列',
    add_title_group: '添加广告组',
    add_title_adv: '添加广告',
    verify: '广告系列状况：账号已验证',
    verify_group: '广告组状况：账号已验证',
    verify_adv: '广告状况：账号已验证',
    sum_text: '汇总',
    search: '搜索',
    show: '展示',
    shopping: '购物',
    video: '视频',
    ai: '智能',
    find: '发现',
    edit_plan_title1: '修改广告系列名',
    edit_plan_title2: '修改广告系列预算',
    old_plan_title1: '原广告计划名',
    new_plan_title1: '新广告系列名',
    old_plan_title2: '原广告系列预算',
    new_plan_title2: '新广告系列预算',
    edit_group_title1: '修改广告组名',
    edit_group_title2: '选择一个广告系列',
    old_group_title1: '原广告组名',
    new_group_title1: '新广告组名',
    adv_video_label: '视频演示',
    edit_adv_title1: '修改广告名',
    edit_adv_title2: '选择一个广告组',
    old_adv_title1: '原广告名',
    new_adv_title1: '新广告名',
    td_index: '开关',
    td_edit: '编辑',
    td_delete: '删除',
    td_doing: '操作',
    td_state: '状态',
    state_start: '启动',
    state_stop: '暂停',
    td_plan: '广告系列',
    td_group: '广告组',
    td_adv: '广告',
    td_video: '查看视频',
    td1: '预算',
    td2: '广告系列类型',
    td3: '展示次数',
    td4: '点击率',
    td5: '费用',
    td6: '出价策略类型',
    td7: '点击次数',
    td8: '转化率',
    td9: '转化次数',
    td10: '平均每次点击费用',
    td11: '每次转化费用',
    td12: '尽可能争取更多点击次数',
    td13: '广告组类型',
    td14: '标准',
    td15: '动态',
    td16: '广告类型'
  },

  // 新增广告公共
  adv_common: {
    first: '广告系列设置',
    second: '设置广告组',
    third: '设置广告',
    end: '完成',
    save_btn1: '保存并继续',
    save_btn2: '保存',
    next: '继续'
  },

  // 新建广告系列
  create_plan: {
    target_title: '请选择想要达到的目标，该广告系列只要达到这一目标，对您而言即取得理想效果',
    target1: '销售',
    target2: '潜在客户',
    target3: '网站流量',
    target4: '产品和品牌钟意度',
    target5: '品牌认知度和覆盖面',
    target6: '应用宣传',
    target7: '本地实体店光顾和促销',
    target8: '在没有目标导向的情况下制作广告系列',
    plan_title: '选择广告系列类型',
    plan1: '向对您的产品或服务感兴趣的客户展示文字广告',
    plan2: '在整个网络上投放各类广告',
    plan3: '投放购物广告来宣传您的产品',
    plan4: '覆盖TikTok及整个网络上的视频观看者，吸引他们与广告互动',
    plan5: '通过在TikTok和整个网络中投放自动生成的广告，帮助您实现业务目标',
    plan6: '在TikTok探索及其他更多优质广告空间投放广告',
    type_title: '选择您希望通过何种方式达成目标',
    type1: '网站访问次数',
    type2: '来电次数',
    type3: '应用下载',
    default_set: '常规设置',
    type: '类型：',
    target: '目标：',
    title: '广告系列名称',
    title_p: '请输入广告系列名称',
    network: '投放网络',
    network_desc: '包括 TikTok 搜索网络合作伙伴',
    network_title: '展示广告网络',
    network_content: '如果用户搜索与关键字相关的字词，广告就会在 TikTok 搜索结果旁边和其他 TikTok 网站上展示',
    date: '开始日期和结束日期',
    date_s: '开始日期',
    date_e: '结束日期',
    date_p: '选择日期',
    date_desc1: '除非指定结束日期，',
    date_desc2: '否则您的广告将持续投放下去。',
    set_title: '动态搜索广告设置',
    set_title1: '输入标题',
    set_title_p: '请输入标题',
    set_desc: '选择此广告系列中动态搜索广告的语言',
    set_options: '请选择',
    set_position: '选择定位来源',
    set_options1: '使用 TikTok 为我的网站编制的索引',
    set_options2: '仅使用来自我的页面 Feed 的网址',
    set_options3: '同时使用TikTok为我网站编制的索引中的网址和我的页面Feed中的网址',
    font: '动态搜索广告 (DSA)',
    font_content1: '会根据您网站上的内容自动定位相关搜索，',
    font_content2: '然后使用根据用户的实际搜索内容自动定制的标题。',
    font_content3: '此设置用于决定要为您的动态搜索广告使用什么网域、',
    font_content4: '语言和定位来源。要制作动态搜索广告，',
    font_content5: '您需要在下一步中创建动态广告组。',
    time: '广告投放时间',
    time_content: '全天',
    position_title: '定位和受众群体',
    position_title2: '选择您要覆盖的受众群体',
    position: '地理位置',
    position_desc: '选择要定位到的地理位置',
    country: '所有国家和地区',
    china: '中国',
    other: '输入其他地理位置',
    other_p: '请输入地理位置',
    other_desc: '例如，国家/地区、城市、区域或邮政编码',
    languare: '语言',
    languare_title: '选择目标用户所使用的语言',
    languare_title2: '您的广告会展示给采用这些语言偏好设置的客户，或者展示在采用这些语言的网站上。',
    languare_p: '试试搜索：指南',
    languare_desc1: '要向将语言偏好设置为西班牙语的用户展示广告，',
    languare_desc2: '请将西班牙语选为您的广告系列语言并使用西班牙语广告文字和关键词',
    price1: '预算和出价',
    price2: '指定您要支出多少费用以及支出方式',
    price_title: '预算',
    price_title2: '输入您希望平均每天花费的金额',
    price_title_p: '请输入金额',
    group_price: '组出价',
    group_price_p: '请输入组出价',
    price_desc1: '您每月的实际支出不会超过每日预算与一个月平均天数的乘积。',
    price_desc2: '有些天的实际支出可能低于每日预算，',
    price_desc3: '而有些天的实际支出最多可能会达到每日预算的两倍。',
    pay: '出价',
    pay_title: '您希望着重实现的目标是什么？',
    pay_desc: '为您的广告系列推荐的选项',
    num: '转化次数',
    num_title: '请选择将哪些转化纳入到此广告系列的“转化次数”列中，进而用于智能出价',
    num_option1: '使用帐号级“纳入到‘转化次数’列中”设置',
    num_option2: '为此广告系列选择转化操作',
    banner: '广告轮播',
    banner1: '优化：优先展示效果最佳的广告',
    banner2: '不优化：无限期轮播广告',
    banner3: '针对转化进行优化（不支持）',
    banner4: '均匀轮播（不支持）',
    plan_desc: '广告计划',
    target_verify: '请选择一个目标',
    type_verify: '请选择一个类型',
    title_verify: '广告系列名称不能为空',
    budget_verify: '预算不能为空',
    group_price_verify: '组出价不能为空',
    price_type1: '推荐',
    price_type2: '转换次数',
    price_type3: '转换价值',
    price_type4: '其他优化选项',
    price_type5: '点击次数',
    price_type6: '展示次数份额',
  },

  // 语言
  languare: {
    a1: '阿拉伯语',
    a2: '保加利亚语',
    a3: '捷克语',
    a4: '丹麦语',
    a5: '德语',
    a6: '现代希腊语',
    a7: '英语',
    a8: '西班牙语',
    a9: '爱沙尼亚语',
    a10: '波斯语',
    a11: '芬兰语',
    a12: '法语',
    a13: '克罗地亚语',
    a14: '匈牙利语',
    a15: '意大利语',
    a16: '立陶宛语',
    a17: '拉脱维亚语',
    a18: '挪威语',
    a19: '荷兰语',
    a20: '波兰语',
    a21: '葡萄牙语',
    a22: '罗马尼亚语',
    a23: '俄语',
    a24: '斯洛伐克语',
    a25: '斯洛文尼亚语',
    a26: '塞尔维亚语',
    a27: '瑞典语',
    a28: '土耳其语',
    a29: '乌克兰语',
    a30: '汉语'
  },

  // 新建广告组
  create_group: {
    title: '设置广告组',
    desc: '一个广告组包含一个或多个广告以及一组相关的关键字。要获得最佳效果，请尽量让一个广告组中的所有广告和关键字均围绕一种产品或服务。',
    group: '广告组',
    group_name: '广告组名称',
    group_name_p: '请输入广告组名称',
    keyword: '关键字',
    keyword_desc: '通过描述此广告组中广告所宣传对象来查找相关关键字',
    url: '请输入相关网页地址',
    url_title: '请输入相关网页标题',
    keyword_title: '关键字是用来将您的广告和用户搜索的字词联系起来的字词或词组',
    keyword_line: '输入或粘贴您的关键字，每行一个字词或词组',
    group_name_verify: '广告组名称不能为空',
    url_verify: '广告组链接不能为空',
    url_title_verify: '广告组链接标题不能为空',
    content_verify: '广告组关键词不能为空'
  },

  // 新建广告
  create_adv: {
    title: '制作广告',
    desc: '建议您为每个广告组制作一个广告效力至少为“良好”的自适应搜索广告，且广告内容应与关键字的主题密切相关。',
    group_name: '广告组：',
    keyword: '关键字：',
    keyword_desc: '与制作多个文字广告相比，制作一个自适应搜索广告可以带来更理想的效果。',
    title2: '使用自适应授索广告时，您需要输入多个标题和多条广告内容描述。然后TikTok会将它们合并到广告中。',
    url: '请输入链接',
    name: '标题',
    name_p: '新标题',
    upload: '上传视频',
    upload_btn: '浏览...',
    right_title: '广告效力',
    state: '良好',
    right_keyword: '尝试在标题中包含更多关键字',
    keyword1: '添加更多标题',
    keyword2: '在标题中包含热门关键字',
    keyword3: '让您的标题更独特',
    keyword4: '让您的广告内容描述更独特',
    look: '预览',
    look_content: '此预览画面展现了使用您的素材资源可能会制作出什么样的广告。并非所有组合都会显示出来。素材资源可能会以任意顺序展示，因此请确保它们无论是单独使用还是组合使用都行得通，且不违反我们的政策或当地法律。在某些广告格式中，可能会出现一定程度的省略。 您可以确保在广告中始终显示某些文字。',
    create: '新建',
    edit: '修改',
    adv: '广告',
    url_verify: '链接不能为空',
    title_verify: '标题不能为空',
    video_verify: '请上传视频',
    video_type: '请上传正确的视频格式',
    video_size: '视频大小不能超过100MB',
    success: '操作成功'
  },

  ...zhLocale
}

export default cn;
